import React from "react";
import { observer } from "mobx-react-lite";
import { Box, Divider, Text } from "@chakra-ui/react";
import UnitMeasurement from "./UnitMeasurement/UnitMeasurement";
import { useTranslation } from "react-i18next";
import { SCREEN_VERTICAL_SPACING } from "../../constants";
import Timezone from "./Timezone/Timezone";

interface SettingsProps {}

const Settings: React.FC<SettingsProps> = () => {
  const { t } = useTranslation("translation", {
    keyPrefix: "settings",
  });

  return (
    <Box mx={"40px"} my={SCREEN_VERTICAL_SPACING}>
      <Text fontSize="3xl" color="black">
        {t("settings")}
      </Text>
      <Text fontSize="md" color="#3A3A3A">
        {t("adjustYouPreferences")}
      </Text>

      <Box color="black" mb={8}>
        <Timezone />
      </Box>
      <Divider w="620px" borderColor="#C0C0C0" mb={8} />
      <Box color="black">
        <UnitMeasurement />
      </Box>
    </Box>
  );
};

export default observer(Settings);
